export function createLocationStore() {
  const store = new Map<string, Map<string, unknown>>();

  return {
    get: (locationKey: string, componentKey: string) => {
      const state = store.get(locationKey);
      if (state) {
        return state.get(componentKey);
      }
    },
    put: (locationKey: string, componentKey: string, value: unknown) => {
      const state = store.get(locationKey) ?? new Map();
      state.set(componentKey, value);
      store.set(locationKey, state);
    },
  };
}
